import md5 from 'js-md5';

const FP_CACHE_KEY = 'terminalMac';
const FINGERPRINT_PATTERN = /^[a-f0-9]{32}$/i;

function getCanvasFingerprint() {
  try {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) return '';

    const text = 'terminal-mac-fingerprint';
    context.textBaseline = 'top';
    context.font = '14px Arial';
    context.fillStyle = '#f60';
    context.fillRect(125, 1, 62, 20);
    context.fillStyle = '#069';
    context.fillText(text, 2, 15);
    context.fillStyle = 'rgba(102, 204, 0, 0.7)';
    context.fillText(text, 4, 17);
    return canvas.toDataURL();
  } catch (e) {
    return '';
  }
}

function getBrowserInfo() {
  const nav = typeof navigator === 'undefined' ? {} : navigator;
  const display = typeof screen === 'undefined' ? {} : screen;

  return [
    nav.userAgent || '',
    nav.language || '',
    nav.platform || '',
    nav.vendor || '',
    `${display.width || 0}x${display.height || 0}`,
    display.colorDepth || 0,
    new Date().getTimezoneOffset(),
    nav.hardwareConcurrency || 0,
    nav.deviceMemory || 0,
    getCanvasFingerprint()
  ].join('|');
}

/**
 * Returns the stable opaque value sent to the API as X-Device-Fingerprint.
 * The server hashes this value again before using it in Redis keys.
 */
export function getDeviceFingerprint() {
  try {
    const cached = localStorage.getItem(FP_CACHE_KEY);
    if (cached && FINGERPRINT_PATTERN.test(cached)) {
      return cached;
    }
  } catch (e) {
    // Private browsing can disable storage; the current page can still use
    // the deterministic browser signal as its device value.
  }

  const fingerprint = md5(getBrowserInfo());
  try {
    localStorage.setItem(FP_CACHE_KEY, fingerprint);
  } catch (e) {
    // Storage is an optimization, not a prerequisite for making requests.
  }
  return fingerprint;
}

// Keep the old name for existing imports in the application.
export const getTerminalMac = getDeviceFingerprint;

export function resetTerminalMac() {
  try {
    localStorage.removeItem(FP_CACHE_KEY);
  } catch (e) {
    // Ignore storage errors in restricted browser contexts.
  }
}
